module.exports = __webpack_public_path__ + "img/c.0d4eeb5b.jpg";